import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "./Header";
import useVirtualViewport from "../../../hooks/useVirtualViewport";
import { Outlet, useLocation } from "react-router-dom";

import {
  setOpenDriverSidebar,
  toggleKeyboard,
} from "../../../redux/features/settingSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import DriverSidebar from "./Sidebar";

export default function DriverLayout() {
  const viewport = useVirtualViewport();

  const { pathname } = useLocation();

  const dispatch = useAppDispatch();

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  useEffect(() => {
    console.log(viewport);

    const handleResize = () => {
      if (viewport?.height) {
        if (viewport.height < window.innerHeight) {
          dispatch(toggleKeyboard(true));
        } else {
          dispatch(toggleKeyboard(false));
        }
      }
    };

    handleResize();
  }, [viewport?.height]);

  useEffect(() => {
    dispatch(setOpenDriverSidebar(false));
  }, [pathname]);

  return (
    <Box
      sx={{
        direction: "rtl",
        height: !isOpenKeyboard ? `${viewport?.height}px` : "100vh",
        maxWidth: "500px",
        marginX: "auto",
        backgroundColor: "background.paper",
        overflowY: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DriverSidebar />
      <Outlet />
    </Box>
  );
}
